import React from 'react';
import './style.css';

const Timeline = ({ children }) => {
    return (
        <div>
            <div className="timeline">{children}</div>
        </div>
    );
};

export default Timeline;
